import { flattenItems } from "src/common/flattenItems";
import { ZMenuItem } from "src/components/MainFrame/LeftMenu/ZMenuItem";

export const generateNewId = (items: ZMenuItem[]): number => {
  const flattenedItems = flattenItems(items, "elements") ?? [];
  const maxId = flattenedItems.reduce((max, { id }) => Math.max(max, id), 0);
  return maxId + 1;
};
